export const prepareUrl = (url, code) => {
    const splitUrl = url.split('/')
    if(splitUrl?.includes('incident')){
        return `/incident/${code}`
    }else {
        return url
    }
}

// Short code URLs come from the API, so only follow paths that the browser resolves to this same site
export const isInternalPath = (url) => {
    if (typeof url !== 'string' || !url.startsWith('/')) return false
    try {
        return new URL(url, window.location.origin).origin === window.location.origin
    } catch {
        return false
    }
}